<template>
    <div class="container mt-5">
        <div class="card">
            <div class="card-header">{{item.name}}</div>
            <div class="card-body" v-html="item.body">
            </div>
        </div>
    </div>
</template>

<script>
    import config from '../config';
    export default {
        props: ['post_id'],
        data () {
            return {
                item: {}
            }
        },
        mounted() {
            this.index();
        },
        watch: {
          post_id: function () {
              this.index()
          }
        },
        methods: {
            index() {
                axios.get(config.urlBase+ '/api/v1/public/posts/'+this.post_id).then((res) => {
                    this.item = res.data.data;
                }).catch((err) => {
                    console.error(err);
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PreventComponent.vue